import { WintSuperkollAPIModel } from "wint-api-client/dist/types";

export interface AuditSheetFile {
  attachmentId: string;
  wintAccountingVoucherId?: string;
  fileName?: string;
  contentType?: string;
  rowIndex: number;
}

export interface AuditSheetRowFiles {
  fileCount: number;
  firstFileIndex?: number;
}

export interface AuditSheetFileList {
  files: AuditSheetFile[];
  rows: AuditSheetRowFiles[];
}

export const buildAuditSheetFileList = (items?: WintSuperkollAPIModel.AuditSheetItem[]): AuditSheetFileList => {
  const files: AuditSheetFile[] = [];

  const rows = (items ?? []).map((item, rowIndex): AuditSheetRowFiles => {
    const firstFileIndex = files.length;

    if (item.attachment?.id) {
      files.push({
        attachmentId: item.attachment.id,
        fileName: item.attachment.name,
        contentType: item.attachment.contentType,
        rowIndex,
      });
    }

    // Voucher images carry no name or type here; the viewer detects the type from the fetched data.
    if (item.wintAccountingVoucherId) {
      (item.wintAccountingVoucherImageIds ?? []).forEach((imageId) =>
        files.push({ attachmentId: imageId, wintAccountingVoucherId: item.wintAccountingVoucherId, rowIndex })
      );
    }

    const fileCount = files.length - firstFileIndex;
    return { fileCount, firstFileIndex: fileCount > 0 ? firstFileIndex : undefined };
  });

  return { files, rows };
};

export const getRowIndexOfFile = (files: AuditSheetFile[], fileIndex?: number) =>
  fileIndex === undefined ? undefined : files[fileIndex]?.rowIndex;
